<div class="or-pt-32-px or-mx-24-px action-push-modal">
  <div class="or-d-flex or-justify-content-center">
    <span class="or-head-xl or-mb-16-px or-text-align-center"
      >Zaproś dawnych graczy - czyli jak zwrócić się do ludzi, którzy z Tobą wcześniej grali?
    </span>
  </div>

  <img class="or-mb-20-px or-w-100-pc" src="assets/action-push/invite.jpg" />

  <div class="or-text-lg or-mb-20-px">Zapraszaj znajomych z boiska jednym kliknięciem!</div>
  <div class="or-text-lg or-mb-20-px">
    Dzięki tej funkcji szybko dodasz do gry osoby, które już z Tobą grały. To większa szansa, że chętnie dołączą
    ponownie, a Ty unikniesz stresu z szukaniem graczy na ostatnią chwilę!
  </div>
</div>

<div class="or-mb-12-px or-mx-24-px or-mt-12-px">
  <button class="button-primary-style or-h-48-px or-head-md or-w-100-pc or-mb-12-px" (click)="closeModal()">
    Wróć do głównego ekranu
  </button>
</div>
